import { render, staticRenderFns } from "./BaseDetailTable.vue?vue&type=template&id=3dc88595&scoped=true"
import script from "./BaseDetailTable.vue?vue&type=script&lang=js"
export * from "./BaseDetailTable.vue?vue&type=script&lang=js"
import style0 from "./BaseDetailTable.vue?vue&type=style&index=0&id=3dc88595&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc88595",
  null
  
)

/* custom blocks */
import block0 from "./BaseDetailTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports